import Login from "../../Components/Login/Login";

function Auth() {
  return <Login />;
}

export default Auth;
